module.exports = __webpack_public_path__ + "img/know.c7260ff6.png";